<template>
    <div class="publication__success content-width">

        <div class="publication__success-block">

            <div class="publication__success-content d-flex">
                <div class="publication__success-title">
                    Большое спасибо за публикацию, ваше объявление отправлено на модерацию!
                </div>
            </div>
        </div>

        <div class="publication__success-action d-flex">
            <a class="btn publication__btn publication__btn--primary" :href="`/pets/${server.createdTarget}`"
               v-if="server && server.createdTarget">
                Перейти в карточку животного
            </a>
        </div>

    </div>
</template>

<script>
export default {
    name: "PublicationSuccess",
    props: ['server']
}
</script>

<style scoped>

</style>
